import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import FloatingBanner, {
  FLOATING_BANBER_COLORS,
  FloatingBannerProps,
} from 'components/FloatingBanner/FloatingBanner.component';
import DiscoveryFeatureCard from 'components/DiscoveryFeatureCard';
import { POSITION } from 'models/Position';
import { DiscoveryFeatureCardProps } from 'components/DiscoveryFeatureCard/DiscoveryFeatureCard.component';

import './DiscoveringFeature.styles.scss';

type DiscoveringFeatureProps = {
  className?: string;
  createdAt?: Date | string;
  onCtaClick?: () => void;
} & FloatingBannerProps &
  Partial<DiscoveryFeatureCardProps>;

const DiscoveringFeature: React.FC<DiscoveringFeatureProps> = (props) => {
  const {
    className,
    createdAt,
    title,
    description,
    onCtaClick,
    onClose,
    ...rest
  } = props;

  const classes = classNames('discovering-feature', className);

  const handleCtaClick = useCallback(() => {
    onCtaClick?.();
    onClose?.();
  }, [onCtaClick, onClose]);

  const discoveryFeatureCard = useMemo(
    () => (
      <DiscoveryFeatureCard
        createdAt={createdAt}
        title={title}
        description={description}
        onUnderstood={handleCtaClick}
      />
    ),
    [createdAt, title, description, handleCtaClick],
  );

  if (!discoveryFeatureCard) return null;

  return (
    <FloatingBanner
      hasCloseButton
      color={FLOATING_BANBER_COLORS.WHITE}
      preferredPosition={POSITION.BOTTOM}
      className={classes}
      onClose={handleCtaClick}
      {...rest}
    >
      {discoveryFeatureCard}
    </FloatingBanner>
  );
};

export default DiscoveringFeature;
